/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Divider, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Select, SelectItem } from '@nextui-org/react';
import { useSelector } from 'react-redux'
import toast from 'react-hot-toast';
import { TeacherGroupService } from '../../../../services';
import { formatNumericFields } from '../../../../utils';
import { IconTrash } from '@tabler/icons-react';
import moment from 'moment';


const MODAL_ACTION = {
  DELETE_LAPSE: 1
}


const ModalCreateGroup = ({ item, onSuccess, onClose }) => {
  const { addGroup, form, onChange, onSubmit, removeGroup, lapses, schoolYears, deleteLapse } = useForm(item);
  const [modalAction, setModalAction] = useState(MODAL_ACTION.NONE);
  const [selectedItem, setSelectedItem] = useState();

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  const onSelectItem = (item, action) => {
    setSelectedItem(item)
    setModalAction(action);
  }

  const closeModal = (reloading = false) => {
    setModalAction(MODAL_ACTION.NONE);
  }

  return (
    <>
      <Modal
        size="md"
        isOpen={modalAction !== MODAL_ACTION.NONE}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            return (
              <ModalDeleteLapse
                item={selectedItem}
                onClose={onClose}
                onDelete={async () => {
                  const { lapseIdx, ...rest } = selectedItem;
                  await deleteLapse(rest.id, lapseIdx);
                  closeModal(true);
                  onSuccess()
                }}
              />
            )
          }}
        </ModalContent>
      </Modal>

      <ModalHeader className="flex flex-col gap-1">{!!item ? 'Editar' : 'Nuevo'}</ModalHeader>
      <ModalBody className="gap-8">
        <div className="flex flex-col flex-1 gap-4">
          <Select
            label="Año escolar"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            classNames={{ label: 'font-semibold' }}
            disallowEmptySelection={true}
            selectedKeys={!!form.school_year_id ? [form.school_year_id] : []}
            onSelectionChange={v => onChange(v.currentKey, 'school_year_id')}
          >
            {schoolYears.map((item) => (
              <SelectItem key={item.id} value={item.id}>
                {item.name}
              </SelectItem>
            ))}
          </Select>

          <Divider />

          <Input
            label="Lapso"
            labelPlacement="outside"
            placeholder=" "
            radius="sm"
            variant="bordered"
            value={form._groupLapse}
            onValueChange={v => onChange(v, '_groupLapse')}
          />
          <div className="grid grid-cols-2 gap-4">
            <Input
              label="Inicia"
              labelPlacement="outside"
              placeholder=" "
              type="date"
              radius="sm"
              variant="bordered"
              value={form._groupStart}
              onValueChange={v => onChange(v, '_groupStart')}
            />
            <Input
              label="Finaliza"
              labelPlacement="outside"
              placeholder=" "
              type="date"
              radius="sm"
              variant="bordered"
              value={form._groupEnd}
              onValueChange={v => onChange(v, '_groupEnd')}
            />
          </div>

          <Button
            variant="flat"
            onClick={addGroup}
            isDisabled={!form._groupLapse || !form._groupStart || !form._groupEnd}
          >
            Agregar
          </Button>

          <Divider />

          {!!lapses.length && (
            <div className="text-sm font-medium">
              <div className="flex justify-between bg-default-100 p-2 rounded-lg">
                <div className='grid grid-cols-3 w-full'>
                  <span>Nombre</span>
                  <span>Inicio</span>
                  <span>Finalización</span>
                </div>
                <span className='w-6 h-6'></span>
              </div>
              {lapses.map((lapse, lapseIdx) => (
                <div key={lapseIdx} className="flex justify-between p-2 border-b border-default-200">
                  <div className='grid grid-cols-3 w-full'>
                    <span>{lapse.name}</span>
                    <span>{moment(lapse.init_date).format('DD-MM-YYYY')}</span>
                    <span>{moment(lapse.end_date).format('DD-MM-YYYY')}</span>
                  </div>
                  <div className="flex justify-end">
                    <IconTrash className="cursor-pointer" onClick={() => {
                      if (lapse.id) return onSelectItem({ ...lapse, lapseIdx }, MODAL_ACTION.DELETE_LAPSE)
                      removeGroup(lapseIdx)
                    }} />
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button className="bg-green" color="primary" onPress={submit}>Guardar</Button>
      </ModalFooter>
    </>
  )
}

const ModalDeleteLapse = ({ item, onClose, onDelete }) => {
  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Confirmación</ModalHeader>
      <ModalBody>
        <p className="text-center">¿Estás seguro de eliminar el lapso?. <span className='font-bold'>{item?.name}</span> Puede que posea registros de evaluaciones asociadas, al eliminarse se eliminarán también dichos registros</p>
        <p className="text-center font-medium">{item.year}</p>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button color="danger" onPress={onDelete}>Aceptar</Button>
      </ModalFooter>
    </>
  )
}


const useForm = (item) => {
  const initialForm = {
    school_year_id: '',
    groups: [],
    _groupLapse: '',
    _groupStart: '',
    _groupEnd: '',
  };
  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);
  const [canFetch, setCanFetch] = useState(true);
  const [schoolYears, setSchoolYears] = useState([]);
  const [lapses, setLapses] = useState([]);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }


  const isValidGroup = () => {
    const currentSchoolYear = schoolYears.find(s => s.id === +form.school_year_id);
    const repeatName = lapses.find(g => g.name.trim().toLowerCase() === form._groupLapse.trim().toLowerCase());

    if (repeatName)
      return onError('El nombre del lapso ya está registrado');

    if (!form.school_year_id)
      return onError('Debe seleccionar el año escolar');

    if (moment(form._groupStart).isSameOrAfter(moment(form._groupEnd)))
      return onError('La fecha de inicio no puede ser mayor a la de finalización');

    if (moment(currentSchoolYear.init_date).isAfter(form._groupStart))
      return onError('La fecha de inicio no puede ser menor a la de inicio del año escolar');

    if (moment(currentSchoolYear.end_date).isBefore(form._groupEnd))
      return onError('La fecha de finalización no puede ser mayor a la de finalización del año escolar');

    return true;
  }

  const addGroup = () => {
    if (!isValidGroup()) return;
    setLapses([
      ...lapses,
      {
        school_year_id: +form.school_year_id,
        name: form._groupLapse,
        init_date: form._groupStart,
        end_date: form._groupEnd,
      }
    ]);

    setForm(s => ({
      ...s,
      _groupLapse: '',
      _groupStart: '',
      _groupEnd: '',
    }));
  }

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const response = await TeacherGroupService.groups.getSchoolYears();
      setSchoolYears(response);
      setCanFetch(true);

    } catch (error) {
      setSchoolYears([]);
      onError(String(error));
    }
  }

  const removeGroup = (index) => {
    setLapses(lapses.filter((_, idx) => index !== idx));
  }


  const deleteLapse = async (lapseId, lapseIdx) => {
    try {
      await TeacherGroupService.groups.deleteLapse({ id: lapseId });
      toast.success('Lapso eliminado con éxito');
      removeGroup(lapseId, lapseIdx);
    } catch (error) {
      onError(String(error));
    }
  }


  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const isValidForm = () => {
    if (!form.school_year_id)
      return onError('Debe seleccionar el año escolar');

    if (!lapses.length)
      return onError('Debe indicar al menos un lapso');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    try {
      const numericFields = ['school_year_id']
      const formattedData = formatNumericFields(form, numericFields);
      const data = { ...formattedData, professor_id: user.id, lapses: lapses.filter(x => !x.id) }

      await TeacherGroupService.groups.createLapse(data);

      toast.success(`Lapso ${item ? 'editado' : 'creado'} correctamente`)
      return true;

    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  useEffect(() => {
    fetchData();

    if (!!item) {
      setForm({
        school_year_id: item.id?.toString(),
      });
      setLapses(item.lapses.map((x) => ({
        school_year_id: item.id,
        ...x
      })))
    }
  }, [])

  return {
    addGroup,
    form,
    lapses,
    onChange,
    onSubmit,
    removeGroup,
    schoolYears,
    deleteLapse
  }
}

export default ModalCreateGroup;
